import { render, staticRenderFns } from "./SolutionsAndConsultancy.vue?vue&type=template&id=6c07c8f3&scoped=true&"
import script from "./SolutionsAndConsultancy.vue?vue&type=script&lang=js&"
export * from "./SolutionsAndConsultancy.vue?vue&type=script&lang=js&"
import style0 from "./SolutionsAndConsultancy.vue?vue&type=style&index=0&id=6c07c8f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c07c8f3",
  null
  
)

export default component.exports